import { Tooltip, TooltipProps } from '@mui/material'
import { Box, BoxProps } from '@mui/system'
import { FC } from 'react'
import { formatActivityCardTime, formatActivityCardTimeWithMs } from '../../activityUtils'

type ActivityTimeValueProps = BoxProps & {
  ms: number
  seconds: number
  fallback?: string
  tooltipProps?: Partial<TooltipProps>
}

export const ActivityTimeValue: FC<ActivityTimeValueProps> = ({ ms, seconds, fallback, tooltipProps, ...boxProps }) => (
  <Tooltip title={formatActivityCardTimeWithMs(ms)} {...tooltipProps}>
    <Box {...boxProps}>{fallback ?? formatActivityCardTime(seconds)}</Box>
  </Tooltip>
)
